import React from "react";
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

interface ActiveFlowConflictDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  conflictingFlowName: string;
  phoneNumberLabel: string;
  onReplace: () => void;
  onSaveInactive?: () => void;
}

export function ActiveFlowConflictDialog({
  open,
  onOpenChange,
  conflictingFlowName,
  phoneNumberLabel,
  onReplace,
  onSaveInactive,
}: ActiveFlowConflictDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="sm:max-w-xl">
        <AlertDialogHeader>
          <AlertDialogTitle>{phoneNumberLabel} already has an active call flow</AlertDialogTitle>
          <AlertDialogDescription>
            Calls to this number are answered by "{conflictingFlowName}". A number can only have one active flow, so
            continuing will turn that one off.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col gap-2 sm:flex-row sm:flex-wrap sm:justify-end">
          <AlertDialogCancel className="mt-0 sm:mr-auto">Cancel</AlertDialogCancel>
          {onSaveInactive && (
            <Button type="button" variant="outline" onClick={onSaveInactive}>
              Save this one turned off
            </Button>
          )}
          <Button type="button" className="max-w-full" onClick={onReplace}>
            <span className="truncate">Turn off "{conflictingFlowName}"</span>
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
